"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const arrow_left_1 = require("../icons/arrow-left");
exports.default = arrow_left_1.ArrowLeft;
